import { Alert, Button, Card, CardBody, Spinner } from '@foundation/ui'
import { Link, createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import styles from './login.module.css'
import { api } from '@/lib/api'

export const Route = createFileRoute('/verify-email')({
  component: VerifyEmailPage,
})

function getToken(): string | null {
  const params = new URLSearchParams(window.location.search)
  return params.get('token')
}

function VerifyEmailPage() {
  const token = getToken()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>(token ? 'loading' : 'error')
  const [message, setMessage] = useState(token ? '' : 'No verification token provided.')

  useEffect(() => {
    if (!token) return

    api
      .verifyEmail({ token })
      .then(() => {
        setStatus('success')
        setMessage('Your email has been verified successfully!')
      })
      .catch((err: unknown) => {
        setStatus('error')
        setMessage(
          err instanceof Error ? err.message : 'Verification failed. The token may be expired.'
        )
      })
  }, [token])

  return (
    <main className={styles.container}>
      <Card className={styles.card}>
        <CardBody>
          <div className={styles.logo}>
            <span className={styles.logoIcon}>🔍</span>
            <span className={styles.logoText}>PriceSpy</span>
          </div>
          <h2 className={styles.title}>Email Verification</h2>

          {status === 'loading' && (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
              <Spinner size="lg" />
            </div>
          )}

          {status === 'success' && (
            <>
              <Alert variant="success" className={styles.alert}>
                {message}
              </Alert>
              <Link to="/login">
                <Button variant="primary" className={styles.fullWidth}>
                  Go to Login
                </Button>
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <Alert variant="danger" className={styles.alert}>
                {message}
              </Alert>
              <Link to="/login">
                <Button variant="secondary" className={styles.fullWidth}>
                  Back to Login
                </Button>
              </Link>
            </>
          )}
        </CardBody>
      </Card>
    </main>
  )
}
